import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import { SharedModule } from '../../shared/shared.module';

import { UIModule } from '../ui/ui.module';

import { OutletsModule } from './outlets/outlets.module';
import { VendorsModule } from './vendors/vendors.module';
import { CustomersModule } from './customers/customers.module';
import { ServicesModule } from './services/services.module';

@NgModule({
  imports: [
    CommonModule,
    SharedModule,
    OutletsModule,
    VendorsModule,
    CustomersModule,
    ServicesModule,
    UIModule
  ],
})

export class DebtsModule {
}
